<template>
  <div class="assignment-history">
    <table class="table table-sm table-bordered w-100">
      <thead>
        <tr>
          <th class="type">Type</th>
          <th></th>
          <th>Details</th>
          <th>Assignee</th>
          <th class="datetime">
            Date
            <small class="text-muted">(Newest First)</small>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="shift.coverRequestStatus" class="coverRequest current">
          <td class="text-center">
            <font-awesome-icon icon="people-arrows"></font-awesome-icon>
          </td>
          <td>Cover Request</td>
          <td colspan="3">currently: {{ shift.coverRequestStatus }}</td>
        </tr>
        <tr
          v-for="(item, index) in historyItems"
          :key="index"
          class="item"
          :class="[item.historyType]"
        >
          <td class="text-center">
            <font-awesome-icon
              :icon="
                item.historyType == 'coverRequest' ? 'people-arrows' : 'user'
              "
            ></font-awesome-icon>
          </td>
          <td>
            {{
              item.historyType == "coverRequest"
                ? "Cover Request"
                : "Assigned To"
            }}
          </td>
          <td>
            <div v-if="item.historyType == 'coverRequest'">
              {{ item.status }}
              {{
                item.coverReason ? " (reason: " + item.coverReason + ")" : ""
              }}
            </div>
            <div v-else>
              {{ item.type }}
            </div>
          </td>
          <td v-if="item.historyType == 'coverRequest'">
            <template v-if="item.approved">
              <user-display-resolver
                v-if="item.approved.userId"
                :user-id="item.approved.userId"
                :display-name="item.approved.displayName"
              />
              was approved by
              <user-display-resolver
                v-if="item.userId"
                :user-id="item.userId"
                :display-name="item.displayName"
              />
            </template>
            <template v-else>
              <user-display-resolver
                :user-id="item.userId"
                :agency-id="item.agencyId"
                :display-name="item.displayName"
              />
            </template>
          </td>
          <td v-else>
            <user-display-resolver
              :user-id="item.userId"
              :agency-id="item.agencyId"
              :display-name="item.displayName"
            />
          </td>
          <td class="datetime">
            <div>
              {{ formatRotaStartDateLong(item.dateModified ?? item.timestamp) }}
            </div>
            {{ formatTimeHoursMins(item.dateModified ?? item.timestamp) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type {
  ProtoRotaCoverRequest,
  ProtoRotaShiftAssignment,
} from "@switchsystems/coactive-rota-lib";
import UserDisplayResolver from "@/components/UserDisplayResolver.vue";
import {
  formatRotaStartDateLong,
  formatTimeHoursMins,
} from "../../../lib/date-functions.js";

const props = defineProps({
  shift: {
    type: Object,
    default() {
      return {};
    },
  },
});

const historyItems = computed(() => {
  const items = [];
  if (props.shift.assignedTo ?? [].length > 0) {
    items.push(
      ...props.shift.assignedTo.map((a: ProtoRotaShiftAssignment<string>) => ({
        ...a,
        historyType: "assignedTo",
      })),
    );
  }
  if (props.shift.coverRequest) {
    items.push(
      ...props.shift.coverRequest.map((cr: ProtoRotaCoverRequest<string>) => ({
        ...cr,
        historyType: "coverRequest",
      })),
    );
  }

  const getDate = (item: any): Date => item.dateModified ?? item.timestamp;
  // sort by newest first
  items.sort((a, b) => getDate(b).getTime() - getDate(a).getTime());

  return items;
});
</script>

<style lang="scss">
.assignment-history {
  table {
    .type {
      width: 3.5em;
    }
    th.datetime {
      width: 18em;
    }
  }
  .coverRequest {
    svg {
      color: var(--cover-request-color);
    }
    &.current {
      --bs-table-color-state: var(--cover-request-color);
      font-weight: bold;
    }
  }
}
</style>
